import { useContext } from 'react';
import { CartContext } from 'src/contexts/CartContext';

// ----------------------------------------------------------------------

const useCart = () => {
    const context = useContext(CartContext);
    if (!context) throw new Error('Cart context must be use inside PageContextProvider');

    return context;
};

export default useCart;
